import { useEffect, useState } from 'react'

import styles from './Time.module.scss'

const TIME_LOCALE: Intl.LocalesArgument = 'en-GB'
const TIME_OPTIONS: Intl.DateTimeFormatOptions = {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
}

export const Time = () => {
    const [date, setDate] = useState(new Date())

    useEffect(() => {
        const timerId = setInterval(() => setDate(new Date()), 1000)

        return () => {
            clearInterval(timerId)
        }
    }, [])

    return <div className={styles.time}>{date.toLocaleTimeString(TIME_LOCALE, TIME_OPTIONS)}</div>
}
